import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaQuestionCircle, FaArrowLeft, FaHome } from 'react-icons/fa';
import './NotFound.css'; // Custom CSS for 404 page styling
import { ROUTE_BASE_URL } from '../../api/common'; // Import base URL from your API config

const NotFound = () => {
  return (
    <div className="container-fluid not-found-wrapper">
      <Container fluid className="d-flex align-items-center justify-content-center min-vh-100">
        <Row>
          <Col xs={12} md={12} lg={12}>
            <Card className="shadow-sm border-0 not-found-card animate__animated animate__fadeIn">
              <Card.Body className="text-center p-5">
                <FaQuestionCircle className="text-primary mb-4" size={60} />
                <Card.Title as="h2" className="font-weight-bold mb-3">
                  404 - Page Not Found
                </Card.Title>
                <Card.Text className="text-muted mb-4">
                  Oops! The page you're looking for doesn't exist or has been moved.
                </Card.Text>
                <Card.Text className="text-muted mb-5">&mdash; AMASI Admin Team</Card.Text>
                <div className="d-flex justify-content-center gap-3">
                  <Button
                    as={Link}
                    to={`${ROUTE_BASE_URL}/`}
                    variant="primary"
                    className="btn btn-sm btn-primary not-found-btn"
                  >
                    <FaHome className="mr-2" /> Dashboard
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFound;